<template>
  <div class="api">
    <div class="filters" v-if="showFilters">
      <div class="container-md">
        <div class="row">
          <div class="col-md-8">
            <div class="search">
              <img height="24" src="/wp-content/themes/isabeltheme/assets/image/search.svg" alt="Search" class="search-icon">
              <input type="text" v-model="searchTerm" @input="updateSearchTerm" :placeholder="$t('searchInstitutions')">
              <div class="reset" @click="clearSearchTerm">X</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="custom-select" @click="toggleDropdown">
              <div class="selected-item">
                <span>{{ selectedCountry ? countries.find(country => country.abbreviation === selectedCountry).country : $t('allCountries') }}</span>
                <img height="24" src="/wp-content/themes/isabeltheme/assets/image/chevron-down-carbon.svg" alt="Search" class="search-icon">
              </div>
              <div class="dropdown" v-show="isDropdownOpen">
                <div class="dropdown-item" @click="selectCountry('')">{{ $t('allCountries') }}</div>
                <div v-for="country in countries" class="dropdown-item" :key="country.abbreviation" @click="selectCountry(country.abbreviation)">
                  <img :src="countryFlag(country.abbreviation.toLowerCase())" :alt="country.country" width="20" height="20">
                  <span>{{ country.abbreviation }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="map-container" @mousedown="startDrag" @mousemove="drag" @mouseup="endDrag" @dblclick="zoomOnDoubleClick" v-show="showMap">
      <div class="europe" :viewBox="viewBox" v-html="svgContent" @click="handleSvgClick"></div>
      <div class="zoombuttons">
        <div @click="zoomIn">+</div>
        <div @click="zoomOut">-</div>
      </div>
    </div> -->
    <div class="container-md">
      <div class="selected-country-info" v-if="showInstitutionsList">
        <div class="top">
          <div class="row">
            <div class="col-md-3">
              <!-- <div class="back" @click="goBack">← {{ $t('backButton') }}</div> -->
              <div class="information">
                <img :src="countryFlag(selectedCountry.toLowerCase())" :alt="selectedCountry" width="50" height="50">
                <div class="text">
                  <p>{{ getCountryName(selectedCountry) }}</p>
                  <p>{{ totalEntries }} {{ $t('banksFound') }}</p>
                </div>
              </div>
              <div class="extrafilters">
                <p>{{ $t('filteredby') }} :</p>
                <div class="checkbox-group">
                  <input
                  type="checkbox"
                  id="payments-enabled"
                  v-model="searchPaymentsEnabled"
                  @change="updatePaymentsFilter"
                  />
                  <label for="payments-enabled">{{ $t('paymentsEnabled') }}</label>
                </div>
                <div class="checkbox-group">
                  <input
                  type="checkbox"
                  id="bulk-payments-enabled"
                  v-model="searchBulkPaymentsEnabled"
                  @change="updateBulkPaymentsFilter"
                  />
                  <label for="bulk-payments-enabled">{{ $t('bulkPaymentsEnabled') }}</label>
                </div>
                <div class="checkbox-group">
                  <input
                  type="checkbox"
                  id="account-info"
                  v-model="accountInfo"
                  />
                  <label for="account-info">{{ $t('accountInfo') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <InstitutionsList :institutions="institutions" />
            </div>
          </div>
        </div>
        <div class="index" v-if="showExampleOne">
          <div class="row">
            <div class="col-md-3">
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-8">
                  <ExampleOne :total-items="totalEntries" :page-size="pageSize" :max-pages-shown="maxPagesShown" :on-page-changed="fetchData" />
                </div>
                <div class="col-md-4 d-flex justify-content-end">
                  <div class="num-banks">{{ this.totalEntries }} {{ $t('banksFound') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="countries" v-if="showContries">
      <div class="row">
        <div v-for="country in countries" class="col-md-3" :key="country.abbreviation">
          <div class="country-box" @click="selectCountry(country.abbreviation)">
            <img :src="countryFlag(country.abbreviation.toLowerCase())" :alt="country.country" width="20" height="20">
            <p>{{ country.country }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import InstitutionsList from './components/InstitutionsList.vue'
  import ExampleOne from './components/ExampleOne.vue'
  import countriesData from '@/assets/countries.json';

  export default {
    name: 'App',
    components: {
      InstitutionsList,
      ExampleOne
    },
    data() {
      return {
        accountInfo: true,
        searchPaymentsEnabled: false,
        searchBulkPaymentsEnabled: false,
        institutions: [],
        totalEntries: 10,
        pageSize: 10,
        maxPagesShown: 10,
        currentPage: 1,
        searchTerm: '',
        selectedCountry: '',
        countries: countriesData,
        isDropdownOpen: false,
        showInstitutionsList: true,
        showFilters: true,
        showMap: true,
        svgContent: '',
        selectedPath: '',
        showContries: true,
        viewBox: '0 0 482 500',
        isDragging: false,
        initialMouseX: 0,
        initialMouseY: 0,
        initialViewBoxX: 0,
        initialViewBoxY: 0,
        zoomFactor: 1.0,
      }
    },
    created() {
      this.loadSVG();
    },
    async mounted() {
      await this.fetchData(this.currentPage);
      window.addEventListener('click', this.closeDropdown);
    },
    beforeUnmount() {
      window.removeEventListener('click', this.closeDropdown);
    },
    computed: {
      showExampleOne() {
        return this.totalEntries > 0;
      },
    },
    methods: {
      async fetchData(pageNumber) {
        try {
          let url = '';
          const params = {
            'page[number]': pageNumber,
            'page[size]': this.pageSize
          };

          if (process.env.NODE_ENV === 'development') {
            url = 'https://myponto/wp-content/themes/isabeltheme/lazy-blocks/api/api-ponto-call.php';
          } else {
            url = '/wp-content/themes/isabeltheme/lazy-blocks/api/api-ponto-call.php';
          }

          if (this.searchTerm) {
            params['filter[name][like]'] = this.searchTerm;
          }
          if (this.selectedCountry) {
            params['filter[country][eq]'] = this.selectedCountry;
          }
          if (this.searchBulkPaymentsEnabled) {
            params['filter[bulk_payments_enabled][eq]'] = true;
          }
          if (this.searchPaymentsEnabled) {
            params['filter[payments_enabled][eq]'] = true;
          }

          url += '?' + new URLSearchParams(params).toString();

          const response = await fetch(url);
          const data = await response.json();
          this.institutions = data.data;
          this.totalEntries = data.meta.paging.totalEntries;
          this.pageSize = data.meta.paging.pageSize;
          this.maxPagesShown = data.meta.paging.maxPagesShown;
        } catch (error) {
          console.error(error)
        }
      },
      updateSearchTerm() {
        this.currentPage = 1;
        this.fetchData(this.currentPage);
        this.showInstitutionsList = true;
        this.showMap = false;
        this.showContries = false;
      },
      updateCountry() {
        this.currentPage = 1;
        this.isDropdownOpen = true;
        this.showFilters = true;
        this.showMap = false;
        this.fetchData(this.currentPage);
      },
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
      closeDropdown(event) {
        if (!event.target.closest('.dropdown') && !event.target.closest('.custom-select')) {
          this.isDropdownOpen = false;
        }
      },
      getCountryName(abbreviation) {
        const country = this.countries.find(country => country.abbreviation === abbreviation);
        return country ? country.country : 'international';
      },
      selectCountry(abbreviation) {
        if(abbreviation) {
          this.selectedCountry = abbreviation;
        } else {
          this.selectedCountry = '';
        }
        this.isDropdownOpen = false;
        this.showInstitutionsList = true;
        this.showContries = false;
        this.updateCountry();
        this.changeCountryColor();
      },
      countryFlag(country) {
        if (process.env.NODE_ENV === 'development') {
          if (!country) {
            return require(`@/assets/svg/int.svg`);
          } else {
            return require(`@/assets/svg/${country.toLowerCase()}.svg`);
          }
        } else {
          if (!country) {
            return "/wp-content/polylang/int.svg";
          } else {
            return "/wp-content/polylang/" + country + ".svg";
          }
        }
      },
      loadSVG() {
        const svgPath =
        process.env.NODE_ENV === 'development'
        ? '/europe2.svg'
        : '/wp-content/polylang/europe.svg';

        fetch(svgPath)
        .then((response) => response.text())
        .then((data) => {
          this.svgContent = data;
        })
        .catch((error) => {
          console.error('Error loading SVG:', error);
        });
      },
      changeCountryColor() {
        const allPaths = document.querySelectorAll('#europe path');
        allPaths.forEach(path => {
          path.style.fill = 'white';
        });

        if (this.selectedCountry) {
          this.selectedPath = document.querySelector(`#europe path[id="${this.selectedCountry}"]`);
          if (this.selectedPath) {
            this.selectedPath.style.fill = '#F2FF00';
          }
        }
      },
      handleSvgClick(event) {
        const clickedPath = event.target;
        if (clickedPath.tagName === 'path') {
          this.selectedCountry = clickedPath.id;
          this.showInstitutionsList = true;
          this.showContries = false;
          this.updateCountry();
          this.changeCountryColor();
        }
      },
      goBack() {
        this.searchTerm = '';
        this.selectedPath = '';
        this.showFilters = true;
        this.showMap = true;
        this.showContries = true;
        this.showInstitutionsList = false;
      },
      clearSearchTerm() {
        this.searchTerm = '';
        this.fetchData(this.currentPage);
      },
      updateBulkPaymentsFilter() {
        this.fetchData(this.currentPage);
      },
      updatePaymentsFilter() {
        this.fetchData(this.currentPage);
      },
      zoomIn() {
        const svg = document.getElementById('europe');
        const viewBox = svg.getAttribute('viewBox').split(' ');
        const newWidth = parseFloat(viewBox[2]) * 0.9;
        const newHeight = parseFloat(viewBox[3]) * 0.9;
        svg.setAttribute('viewBox', `${viewBox[0]} ${viewBox[1]} ${newWidth} ${newHeight}`);
        this.zoomFactor -= 0.1;
      },
      zoomOut() {
        const svg = document.getElementById('europe');
        const viewBox = svg.getAttribute('viewBox').split(' ');
        const newWidth = parseFloat(viewBox[2]) / 0.9;
        const newHeight = parseFloat(viewBox[3]) / 0.9;
        svg.setAttribute('viewBox', `${viewBox[0]} ${viewBox[1]} ${newWidth} ${newHeight}`);
        this.zoomFactor += 0.1;
      },
      zoomOnDoubleClick() {
        const svg = document.getElementById('europe');
        const viewBox = svg.getAttribute('viewBox').split(' ');
        const newWidth = parseFloat(viewBox[2]) * 0.9;
        const newHeight = parseFloat(viewBox[3]) * 0.9;
        svg.setAttribute('viewBox', `${viewBox[0]} ${viewBox[1]} ${newWidth} ${newHeight}`);
        this.zoomFactor -= 0.1;
      },
      startDrag(event) {
        if (event.button === 0) {
          this.isDragging = true;
          this.initialMouseX = event.clientX;
          this.initialMouseY = event.clientY;
          this.initialViewBoxX = parseFloat(this.viewBox.split(' ')[0]);
          this.initialViewBoxY = parseFloat(this.viewBox.split(' ')[1]);
        }
      },
      drag(event) {
        if (this.isDragging) {
          const zoomedWidth = 482 * this.zoomFactor;
          const zoomedHeight = 500 * this.zoomFactor;
          const deltaX = event.clientX - this.initialMouseX;
          const deltaY = event.clientY - this.initialMouseY;
          const newViewBoxX = this.initialViewBoxX - deltaX;
          const newViewBoxY = this.initialViewBoxY - deltaY;
          this.viewBox = `${newViewBoxX} ${newViewBoxY} ${zoomedWidth} ${zoomedHeight}`;
          this.updateViewBoxInSVG(this.viewBox);
        }
      },
      endDrag() {
        this.isDragging = false;
      },
      updateViewBoxInSVG(newViewBox) {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(this.svgContent, 'image/svg+xml');

        const svgElement = svgDoc.querySelector('svg');
        svgElement.setAttribute('viewBox', newViewBox);

        const serializer = new XMLSerializer();
        this.svgContent = serializer.serializeToString(svgDoc);
      },
    }
  }
</script>